import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value"],
  _excluded2 = ["input", "blur", "focus"];
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListeners } from 'vue';
import { storeToRefs } from 'pinia';
import BaseTextField from '~/core/components/Base/BaseTextField.vue';
import useLocaleStore from '~/stores/useLocaleStore';
import { patronymicOptionalRules, patronymicOptionalRulesCis } from '~/features/Profile/functions';
export default /*#__PURE__*/_defineComponent({
  __name: 'PatronymicTextField',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    isEmptyPatronymic: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'focus', 'blur'],
  setup: function setup(__props, _ref) {
    var _props$value;
    var emit = _ref.emit;
    var props = __props;
    var attrs = useAttrs();
    var listeners = useListeners();
    var textField = ref(null);
    var _storeToRefs = storeToRefs(useLocaleStore()),
      isCis = _storeToRefs.isCis;
    var wasInput = ref(false);
    var isErrorState = ref(false);
    var innerValue = ref((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : '');
    var lastValue = ref('');
    var wasFocused = ref(false);
    var rules = computed(function () {
      if (innerValue.value === null) {
        return [];
      }
      return isCis.value ? patronymicOptionalRulesCis : patronymicOptionalRules;
    });
    var isDetailsHidden = computed(function () {
      return innerValue.value === null || !wasFocused.value || !wasInput.value || !isErrorState.value;
    });
    var switchBtnText = computed(function () {
      return innerValue.value === null ? 'Есть отчество' : 'Нет отчества';
    });
    var label = computed(function () {
      return innerValue.value === null ? 'Нет отчества' : 'Отчество';
    });
    var restAttrs = computed(function () {
      var _ = attrs.value,
        rest = _objectWithoutProperties(attrs, _excluded);
      return rest;
    });
    var restListeners = computed(function () {
      var input = listeners.input,
        blur = listeners.blur,
        focus = listeners.focus,
        rest = _objectWithoutProperties(listeners, _excluded2);
      return rest;
    });
    watch(function () {
      return props.value;
    }, function (val) {
      if (innerValue.value !== null) {
        innerValue.value = val;
      }
    });
    watch(innerValue, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(val, prev) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (val !== props.value) {
                emit('input', innerValue.value === null ? '' : innerValue.value);
              }
              if (val === null) {
                textField.value.resetValidation();
              }
              if (!(val === '' && prev === null)) {
                _context.next = 10;
                break;
              }
              isErrorState.value = true;
              wasInput.value = true;
              wasFocused.value = true;
              textField.value.validate(true);
              _context.next = 9;
              return nextTick();
            case 9:
              textField.value.focus();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    onBeforeMount(function () {
      if (props.isEmptyPatronymic && !props.value) {
        innerValue.value = null;
      }
    });
    onMounted(function () {
      isErrorState.value = !textField.value.validate(false);
    });
    function handleFocus(ev) {
      wasFocused.value = true;
      emit('focus', ev);
    }
    function handleBlur(ev) {
      emit('blur', ev);
      setTimeout(function () {
        wasInput.value = true;
      });
    }
    function handleClickSwitch() {
      if (innerValue.value === null) {
        innerValue.value = lastValue.value;
      } else {
        lastValue.value = innerValue.value;
        innerValue.value = null;
      }
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      attrs: attrs,
      listeners: listeners,
      textField: textField,
      isCis: isCis,
      wasInput: wasInput,
      isErrorState: isErrorState,
      innerValue: innerValue,
      lastValue: lastValue,
      wasFocused: wasFocused,
      rules: rules,
      isDetailsHidden: isDetailsHidden,
      switchBtnText: switchBtnText,
      label: label,
      restAttrs: restAttrs,
      restListeners: restListeners,
      handleFocus: handleFocus,
      handleBlur: handleBlur,
      handleClickSwitch: handleClickSwitch,
      BaseTextField: BaseTextField
    };
  }
});